export default __webpack_public_path__ + "static/media/9.b5d5ff70.jpg";